<template>
  <div class="wizard-question-wrapper">
    <div class="wizard-question-header" v-if="title || $slots.description">
      <pf-title h="3">{{ title }} <form-help-tooltip v-if="tooltip" :text="tooltip" /></pf-title>

      <slot name="description" />
    </div>

    <slot />
  </div>
</template>

<style lang="scss">
.wizard-question-wrapper {
  margin-block-end: var(--pf-t--global--spacer--lg);

  &:last-child {
    margin-block-end: 0;
  }
}

.wizard-question-header {
  margin-block-end: var(--pf-t--global--spacer--md);
}
</style>

<script setup lang="ts">
import FormHelpTooltip from '@/components/FormHelpTooltip.vue';

defineProps<{
  title?: string;
  tooltip?: string;
}>();

defineSlots<{
  default: (props?: Record<never, never>) => any;
  description?: (props?: Record<never, never>) => any;
}>();
</script>
